<h2>{{text}}</h2>

<div *ngFor="let user of userList">
    <button routerLink="/users/{{user}}">{{user}}</button>
</div>